// extracted by mini-css-extract-plugin
module.exports = {"variant-conflict-pending-classification-item":"VariantConflictsPendingClassificationItem_variant-conflict-pending-classification-item__qJ6Ef"};